export default "__VITE_ASSET__Bb19jC5y__"